define(function(require,exports,module){"use strict";module.name="widget-hdfc-eva-chat";var base=require("base"),core=require("core"),ui=require("ui"),deps=[core.name,ui.name];module.exports=base.createModule(module.name,deps).constant("WIDGET_NAME",module.name).controller(require("./controllers")).run(function(){})});


// WEBPACK FOOTER //
// ./src/widget-hdfc-eva-chat/scripts/index.js